import { render, staticRenderFns } from "./DragAndDropDebate.vue?vue&type=template&id=6a194792&"
import script from "./DragAndDropDebate.vue?vue&type=script&lang=js&"
export * from "./DragAndDropDebate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports